import { VegaChartMasterColor } from '@asset-metrix/portal-gateway-client-js';
import { useLocalStorage } from '@mantine/hooks';

import { useLoginInfoQuery } from '../../api/portalGateway/loginInfo';
import { COLOR_SCHEME_STORAGE_KEY } from '../../utils/constants';

export type ChartColor = string;

type VegaChartTenantAgnosticColors = {
  textColor: ChartColor;
};

const vegaChartLightScheme: VegaChartTenantAgnosticColors = {
  textColor: 'rgb(7, 23, 32)',
};

const vegaChartDarkScheme: VegaChartTenantAgnosticColors = {
  textColor: 'rgb(235, 240, 241)',
};

type SchemeColors = {
  primaryColor: ChartColor;
  secondaryColor: ChartColor;
  textColor: ChartColor;
  masterColors: VegaChartMasterColor[];
};

export function useVegaSchemeColors(): SchemeColors {
  const [scheme] = useLocalStorage<'dark' | 'light' | undefined>({
    getInitialValueInEffect: false,
    key: COLOR_SCHEME_STORAGE_KEY,
  });

  const { data } = useLoginInfoQuery();
  const tenantThemeVariables =
    scheme === 'light' ? data?.theme?.light : data?.theme?.dark;

  const { textColor } =
    scheme === 'light' ? vegaChartLightScheme : vegaChartDarkScheme;

  const primaryColorVariable =
    tenantThemeVariables?.['--portal-ui-color-primary'];

  const secondaryColorVariable =
    tenantThemeVariables?.['--portal-ui-color-secondary'];

  const masterColors =
    scheme === 'light'
      ? (data?.theme?.light?.['vega-chart-master-color'] ?? [])
      : scheme === 'dark'
        ? (data?.theme?.dark?.['vega-chart-master-color'] ?? [])
        : [];

  return {
    textColor,
    primaryColor:
      primaryColorVariable != null ? `rgb(${primaryColorVariable})` : textColor,
    secondaryColor:
      secondaryColorVariable != null
        ? `rgb(${secondaryColorVariable})`
        : textColor,
    masterColors,
  };
}
